document.querySelectorAll('input[name="show_differences"]').forEach((element) => {
	element.addEventListener('change', (e) => {
		const notDiffRows = e.target
			.closest('.block-compare-table')
			.querySelectorAll('tbody tr:not([data-different="1"]):not(.compare-table__ctas)');

		if (e.target.checked) {
			notDiffRows.forEach((row) => {
				row.style.display = 'none';
			});
		} else {
			notDiffRows.forEach((row) => {
				row.style.display = 'table-row';
			});
		}
	});
});

document.querySelectorAll('.compare-table__sticky td').forEach((el) => {
	const observer = new IntersectionObserver(
		([e]) => {
			e.target.parentNode.classList.toggle('pinned', e.intersectionRatio < 1);
		},
		{ threshold: [1] }
	);

	observer.observe(el);
});
